export const initBSAFormikValues = {
  username: '',
  password: '',
  comment: '',
};

export const initSimAddonFormikValues = {
  recommendPackage: '',
};

export const initPurchaseOfficer = {
  purchaseOfficer: '',
  comment: '',
};

export const initPlantEngineer = {
  plantEngineer: '',
  comment: '',
};

export const initPlantWorkshopManager = {
  plantWorkshopManager: '',
  comment: '',
};

export const initITAdmin = {
  itAdmin: '',
  comment: '',
};

export interface SimCardForm {
  reqCapValue: number;
  mobileNumber: string;
}

export const initSimCardValues: SimCardForm = {
  reqCapValue: 0,
  mobileNumber: '',
};

export const initNewEmailValues = {
  username: '',
  password: '',
};
